import { zip } from 'lodash'
import { DashboardHeader } from '@modules/admin/Admin.Header'
import AnalyticsSample, { validateSampleField } from '@modules/admin/analytics/Analytics.SampleFilter'
import { lineDataParserTotal } from '@modules/admin/analytics/utils'
import AccessControl from '@modules/auth/AccessControl'
import Loading from '@modules/core/components/Loading'
import SelectCompanyField from '@modules/formFields/SelectCompanyField'
import moment from 'moment'
import React, { Component } from 'react'
import { Line } from 'react-chartjs-2'
import { Trans, withTranslation } from 'react-i18next'
import { compose } from 'redux'
import { Field, Form, reduxForm } from 'redux-form/dist/redux-form'
import Professional from '@services/Professional'
import ExportCsv from '../shared/ExportCsv'
import Title from '../shared/Title'

class AnalyticsUsage extends Component {
  state = {
    usageLineChart: undefined,
  }

  client = Professional.analytics

  fetchUsagesChart = (values) => {
    const filters = {
      startDate:
        values.sample.startDate && moment(values.sample.startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      endDate: values.sample.endDate && moment(values.sample.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      sampleRate: values.sample.sampleRate && values.sample.sampleRate,
      apiKeys: values.companyFilter.length ? values.companyFilter.map((co) => co.api_key).join(',') : undefined,
    }

    return this.client
      .getServiceUsageChart(filters)
      .then((response) => this.setState({ usageLineChart: response }))
      .catch((e) => {
        this.setState({ usageLineChart: undefined })
        window.alert(JSON.stringify(e.message, null, 2))
      })
  }

  refresh = () => {
    this.fetchUsagesChart()
  }

  componentDidMount() {
    setTimeout(this.props.submit, 0)
  }

  render() {
    const { usageLineChart } = this.state
    const { handleSubmit, submitting } = this.props

    return (
      <div className="analytics-container">
        <DashboardHeader title={<Trans>Uso del servicio</Trans>} />

        <Form className="container-filters-extended" onSubmit={handleSubmit(this.fetchUsagesChart)}>
          <div className="filter-extended">
            <Field name="sample" component={AnalyticsSample} validate={validateSampleField} />
            <AccessControl role="super-admin">
              <Field name="companyFilter" multi component={SelectCompanyField} />
            </AccessControl>
            {this.props.error && (
              <span style={{ color: 'red' }} className="error">
                {this.props.error}
              </span>
            )}
          </div>
          <div className="container-apply-filters">
            <button className="apply-filters">
              <Trans>Aplicar filtros</Trans>
            </button>
          </div>
        </Form>

        <Loading isFetching={submitting} />

        {usageLineChart && (
          <div className="chart-container">
            <Title title={<Trans>Uso del servicio</Trans>}>
              <ExportCsv
                data={zip(usageLineChart.dates, ...usageLineChart.datasets.map((dataset) => dataset.data))}
                filename={'Uso_del_servicio.csv'}
                headers={['Fecha', ...usageLineChart.datasets.map((el) => el.label)]}
              />
            </Title>
            <Line data={lineDataParserTotal(usageLineChart)} height={70} />
          </div>
        )}
      </div>
    )
  }
}

export default compose(
  withTranslation(),
  reduxForm({
    form: 'analytics',
    initialValues: {
      sample: {
        startDate: moment().startOf('week').toDate(),
        endDate: moment().toDate(),
        sampleRate: 'hour',
        id: 'custom',
      },
      companyFilter: [],
    },
    validate: (values) => ({ _error: validateSampleField(values.sample) }),
    destroyOnUnmount: false,
  })
)(AnalyticsUsage)
